import { api } from 'api'
import jwt from 'jwt-decode'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { useUserStore } from 'store/user'
import { getEnvironment } from 'utils/environment'
import { storage } from 'utils/localStorage'
import { getDashboardToken } from './authentication'
import { getRoleFromId, UserRole } from './utils'

export const NON_PRODUCTION_TOKEN =
  'eyJhbGciOiJFUzI1NiJ9.eyJpc3MiOiJodHRwczovL2NvbnNvbGUuZnliZXIuY29tIiwiYXVkIjoiT0ZXIERhc2hib2FyZCIsImV4cCI6MTY0NDIzNTYzMSwiaWF0IjoxNjQ0MjM1NjAxLCJncm91cF9pZCI6IjEiLCJncm91cF9uYW1lIjoiRnliZXIiLCJzdWIiOiJpYS50ZXN0aW5nLmFhK1N5c3RlbUFkbWluQGdtYWlsLmNvbSIsInJvbGVzIjpbMTAwXX0.X7HMSmTiXBeeYRu08_6CZm-RQ-NKkGw2hfFHT5W2_0hNrYo-DvYdv0N1XAsIr_jCqTO-VVqg7gWN9Nt_3qMSjQ'

export function useConsoleToken() {
  const tokenParam = `console_token`
  const router = useRouter()
  const [consoleToken, setConsoleToken] = useState<string>()

  function removeQueryParam(param: string) {
    const pathname = router.pathname
    const query = { ...router.query }
    delete query[param]

    // Shallow doesn't trigger a rerender
    router.push({ pathname, query }, null, { shallow: true })
  }

  useEffect(() => {
    if (!router.isReady) {
      return
    }

    const token = router.query[tokenParam] as string
    if (token) {
      const user: any = jwt(token)
      const userRoleId = user?.roles[0].toString()
      storage.setValue('role', getRoleFromId(userRoleId))

      setConsoleToken(token)
      removeQueryParam(tokenParam)
    } else if (getEnvironment() !== 'production') {
      setConsoleToken(NON_PRODUCTION_TOKEN)
    }
  }, [router.isReady])

  return consoleToken
}

export function useGetRole() {
  const [userRole, setUserRole] = useState<UserRole>()

  const console_token = useConsoleToken()
  const role = storage.getValue('role') as UserRole

  useEffect(() => {
    if (!role) return
    setUserRole(role)
  }, [role, console_token])

  return { userRole }
}

export function useAuth() {
  const { setToken, token } = useUserStore()
  const consoleToken = useConsoleToken()
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(!!token)

  useEffect(() => {
    if (!consoleToken) {
      return
    }
    authenticate()

    async function authenticate() {
      const dashboardToken = await getDashboardToken(consoleToken)
      if (!dashboardToken) return

      setToken(`Bearer ${dashboardToken}`)
      api.setHeaders({ Authorization: `Bearer ${dashboardToken}` })
      setIsAuthenticated(true)
    }
  }, [consoleToken])

  return { isAuthenticated, consoleToken }
}
